import React from "react";
import { Alert } from "./ui";

const ErrorAlert = ({ errorMessage }) => (
  <Alert tone="error" className="mt-2">
    {errorMessage}
  </Alert>
);

export default ErrorAlert;
